export default {
  noBlocks: 'Der Bericht enthält noch keine Blöcke.',
  addBlock: 'Block hinzufügen',
  expandAll: 'Alle aufklappen',
  collapseAll: 'Alle zuklappen',
  hint: {
    startsOnNewPage: 'Beginnt auf neuer Seite',
    templateReplaced: 'Vorlage ersetzt',
    parametersOnExport: 'Parameter beim Export',
    unavailable: 'Nicht mehr verfügbar',
    onlyFor: 'Nur für {scope}',
  },
};
